import { useNavigate, useParams } from 'react-router-dom';
import { Loader } from '@/components/ui';
import { useGetProfessional } from '@/services';
import { formatProfessionalFullName } from '@/utils';
import { ProfessionalPatientsManager } from '@/pages/professional/patients/components/ProfessionalPatientsManager';

const AdminProfessionalPatients = () => {
	const navigate = useNavigate();
	const { id: professionalId } = useParams<{ id: string }>();

	const { data: professional, isLoading } = useGetProfessional(
		professionalId ?? '',
	);

	if (!professionalId) {
		navigate('/admin/profissionais', { replace: true });
		return null;
	}

	if (isLoading) {
		return (
			<div className="flex items-center justify-center py-24">
				<Loader />
			</div>
		);
	}

	const professionalName = professional
		? formatProfessionalFullName(professional)
		: 'Profissional';

	return (
		<ProfessionalPatientsManager
			professionalId={professionalId}
			professional={professional}
			pageTitle={`Pacientes de ${professionalName}`}
			pageDescription="Gerencie os pacientes vinculados a este profissional."
			listTitle="Pacientes do profissional"
			onBack={() => navigate('/admin/profissionais')}
		/>
	);
};

export { AdminProfessionalPatients };
